import { HolidayList } from "./holiday-list";

export class HolidayGroup {
    
    id: number = 0;
    description!: string;
    active: boolean = false;

    holidayLists: HolidayList[] = [];
}